/**
 * Format a numeric value as a percentage string using Italian locales (comma decimal)
 * - accepts numbers or numeric strings (with dot or comma)
 * - returns fallback (default '-') when value is null/undefined/empty
 */
export function formatPercentage(
  value: number | string | null | undefined,
  options?: { decimals?: number; suffix?: string; locale?: string; fallback?: string }
): string {
  const { fallback = '-' } = options || {}
  if (value === undefined || value === null || value === '') return fallback

  // Convert to string and normalize decimal separator
  let normalized = String(value).trim().replace(',', '.')
  // If not a valid number, fallback
  if (isNaN(Number(normalized))) return fallback

  // Split integer and decimal part
  let [intPart, decPart = ''] = normalized.split('.')
  decPart = decPart.slice(0, 2).padEnd(2, '0')
  let result = intPart + ',' + decPart + '%'
  return result
}

export default formatPercentage
